<template>
  <div class="page-wrapper">
    <router-view></router-view>
  </div>
</template>
<style lang="scss" scoped>
.page-wrapper {
  background-color: $primary-light-2;
}
</style>
